import client from './apiClient';

const postTrialCourseEnrollmentDetails = (data) => client.post(`/individual/user/course`, data);

const createStripeSubscription = (data) => client.post(`/payment/stripe/subscription`, data);

const cancelStripeSubscription = (data) => client.put(`/payment/stripe/subscription`, JSON.stringify(data));

const createAssessmentSubscription = (data) => client.post(`/payment/stripe/subscription/assessment`, data);

const postTrialAssessmentEnrollmentDetails = (data) => client.post(`/individual/user/freeAssessment`, data);

const previewSubscriptionUpgrade = (data) => client.post(`/payment/stripe/subscription/upgrade/preview`, data);

const upgradeSubscription = (data) => client.post(`/payment/stripe/subscription/upgrade`, data);

const getAssessmentPlans = (userId) => client.get(`/individual/user/getAssessmentPlans?userId=${userId}`);
const upgradeFreeSubscription = (data) => client.post(`/individual/user/freeassessmentplan`, data);

export default {
  postTrialCourseEnrollmentDetails,
  createStripeSubscription,
  cancelStripeSubscription,
  createAssessmentSubscription,
  postTrialAssessmentEnrollmentDetails,
  previewSubscriptionUpgrade,
  upgradeSubscription,
  getAssessmentPlans,
  upgradeFreeSubscription
};